import { PayloadAction, ThunkAction, createAction } from "@reduxjs/toolkit";
import { generateReportLatestIdKey } from "@sscs/report/utils";
import type { RootState } from "Store/store";
import { ProjectChange } from "Types";
import { generateReportReturnToKey } from "./reports";

export const resetStoreAction = createAction("RESET_STORE");

export const sessionExpiredAction = createAction("SESSION_EXPIRED");

export const resetStoreThunk =
  (): ThunkAction<void, RootState, unknown, PayloadAction<unknown>> =>
  (dispatch, getState) => {
    Object.keys(getState().reports).forEach((reportKey) => {
      sessionStorage.removeItem(reportKey);
      sessionStorage.removeItem(generateReportLatestIdKey(reportKey));
      sessionStorage.removeItem(generateReportReturnToKey(reportKey));
    });

    dispatch(resetStoreAction());
  };

export const markReportAsDeleted = createAction<string>(
  "MARK_REPORT_AS_DELETED",
);

export const projectCreated = createAction<ProjectChange[]>("PROJECT_CREATED");
export const projectDeleted = createAction<ProjectChange[]>("PROJECT_DELETED");
export const packageCreated = createAction<ProjectChange[]>("PACKAGE_CREATED");
export const packageDeleted = createAction<ProjectChange[]>("PACKAGE_DELETED");
export const versionCreated = createAction<ProjectChange[]>("VERSION_CREATED");
export const versionDeleted = createAction<ProjectChange[]>("VERSION_DELETED");
export const clearVersions = createAction("CLEAR_VERSIONS");
